import { api } from './../../../environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { map } from 'rxjs/operators';

/**
 * Cliente HTTP de los servicios de Barlleno (reports.barlleno.app y
 * service-dev.barlleno.app): productos, órdenes, cupones, tickets, reportes.
 * Antes se llamaba SapService porque también hablaba con SAP; esa
 * integración (inventario y precio por código SAP) se retiró.
 */
@Injectable({
	providedIn: 'root'
})
export class BarllenoApiService {
	url = 'http://jsonplaceholder.typicode.com/posts';
	result: any = ['ND']

	constructor(
		private http: HttpClient,
		public api: ApiService,
	) { }



	//  Peticion post para ejecutar webservice
	async apiPostService(url: string, body: any) {
		return new Promise(async (resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Access-Control-Allow-Origin': 'origin',
					'application': 'x-www-form-urlencoded',
					'Content-type': 'application/json',
					'Access-Control-Allow-Credentials': 'true',
					'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Origin, Cache-Control, Pragma, Authorization, Accept, Accept-Encoding',
					'Access-Control-Allow-Methods': 'PUT, POST, GET, OPTIONS, DELETE'
				})
			};


			this.http.post(url, body, httpOptions)
				.subscribe(async (response) => {
					if (response) {
						resolve(response);

					}
				}, err => {
					resolve(this.result);

				});
		})
	}

	async getPostsTicketevent(token, number, order_key, date,name,categoryKey? :string) {

		console.log('Llamada de Servicio de Tickets');

		
		return new Promise(async (resolve, reject) => {
		 	//this.url = 'https://reports.barlleno.app/barllenoservice/functions/send/notification/emailqr'
		 	this.url = 'https://service-dev.barlleno.app/barllenoservice/functions/send/notification/emailqr'
			//ENTRADAS DE CORTESIA
			//this.url = 'http://localhost:3000/barllenoservice/functions/send/notification/emailqr'

			const httpOptions = {
				headers: new HttpHeaders({
					'Access-Control-Allow-Origin': 'origin',
					'application': 'x-www-form-urlencoded',
					'Content-type': 'application/json',
					'Access-Control-Allow-Credentials': 'true',
					'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Origin, Cache-Control, Pragma, Authorization, Accept, Accept-Encoding',
					'Access-Control-Allow-Methods': 'PUT, POST, GET, OPTIONS, DELETE'
				})
			};

			let body = {
				"token": token,
				"data": {
					"number": number,
                    "date": date,
					"name":name,
					"category":categoryKey
				}
			}

			this.http.post(this.url, body, httpOptions)
				.subscribe((response) => {
					if (response) {
						this.result = response
						resolve(this.result);
						
						
					}
				}
					, err => {
						resolve(this.result);
					}
				);
		
			
			// this.http.post(this.url, body, httpOptions)
			// 	.subscribe(async (response) => {
			// 		if (response) {
			// 			if (response['status'] == 200 && response['message'].toUpperCase().includes('EXITO')) {
			// 				await this.api.updateDocument('orders', order_key, {
			// 					splitETicketSendEmail: true,
			// 				}).then(data => {
			// 					this.result = response
			// 					resolve(this.result);
			// 				})
			// 			}

			// 		}
			// 	}, err => {
			// 		// console.log("error en http.post")
			// 		console.log("err = ", err.response.data)
			// 		resolve(this.result);
			// 	});
			//  resolve(this.result);
		})
	}


	get(url: string, header: HttpHeaders | null = null, test: boolean = false): Observable<any> {
		let urlModifed = ""

		if (test) {
			urlModifed = url
		} else {
			urlModifed = api + url
		}
		return this.http.get<any>(urlModifed, { headers: header }).pipe(map((response) => {
			return response
		}))
	}

	post(url: string, body: any, header: HttpHeaders | null = null, test: boolean = false): Observable<any> {
		let urlPost = "http://localhost:3000"

		if (header === null) {
			header = new HttpHeaders()
			header.append("Content-Type", 'application/json')
		}

		if (test) {
			urlPost = urlPost+ url

		} else {
			urlPost = api + url

		}

		return this.http.post<any>(urlPost, body, { headers: header }).pipe(map((response) => {
			return response
		}))
	}
}
